import Vue from 'vue'
import Vuex from 'vuex'
import {post} from '@/http.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    login_phone: localStorage.getItem('login_phone'),
    score: localStorage.getItem('score'),
    pop: false
  },
  mutations: {
    login(state, phone) {
      state.login_phone = phone
      localStorage.setItem('login_phone', phone)
    },
    logout(state) {
      state.login_phone = null
      state.score = null
      localStorage.removeItem('login_phone')
      localStorage.removeItem('score')
    },
    getScore(state, score) {
      state.score = score
      localStorage.setItem('score', score)
    },
    changePop(state, pop) {
      state.pop = pop
    }
  },
  actions: {
    login(context, phone) {
      context.commit('login', phone)
      post('user/assessment_query')
      .then(res => {
        if(res[0].assessment.date) {
          context.commit('getScore', res[0].assessment.score)
        } else {
          context.commit('changePop', 'auth')
        }
      })
    }
  }
})
